exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=text][data-v-604701a6]{font-size:16px}.task-title.field-value[data-v-604701a6]{padding-top:21px;padding-left:20px}input[type=text].form-control.title-field[data-v-604701a6]{font-size:16px}.reorder-drag-icon[data-v-604701a6]{background:url(/images/reorder-list-with-arrows.svg) no-repeat 50%/contain;display:inline-block;opacity:0;transition:all 1ms;padding-right:0;float:right;margin-right:1rem}.field-control-wrapper .field-wrap:not(.disabled):hover .reorder-drag-icon[data-v-604701a6]{opacity:.5;transition:all 1ms}", ""]);

// exports
